/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
// src/pages/seller/Seller2Net/components/ResultsModal.js
import React from "react";
import { useNavigate } from "react-router-dom";
import EmailModal from "../../popups/EmailModal";
import { useModal } from "../../../../context/ModalContext";
import { useAuth, isGuestUser } from "../../../../context/AuthContext";
import { formatDateMDY } from "../../../../utils/format";

export default function ResultsModal({
  step,
  setStep,
  onEditManual,
  cancelModal,
  cancelResultModal,
  formatCurrency,
  handleDownloadPrintPDF,
  checkValidSalesPrice,
  handleSaveCalc,
  getValues,
  showToaster,
  theme,
}) {
  // Prefer explicit `values` prop; fall back to `formData` for compatibility with older callers
  const data = getValues ? getValues() : {};
  //console.log("ResultsModal data ", data);
  const navigate = useNavigate();
  const main_company_name = theme?.main_company_name;
  const { user } = useAuth();
  const { openModal, closeModal, closeAllModals } = useModal();
  // helper to handle closing so step resets
  const handleClose = () => {
    setStep(1); // go back to step 1 before closing
    closeModal();
  };

  const handleExit = (e) => {
    e.preventDefault();
    setTimeout(() => navigate("/dashboard"), 0);
    closeAllModals();
  };

  const IGNORE_KEYS = ["points_pct", "origination_factor_pct"];
  return (
    <div className="popup-data-result model-popup-style">
      {step === 1 ? (
        <>
          <div className="model-body">
            <div className="heading-gp">
              <p className="heading-b">
                {main_company_name} Calculator has calculated that on a{" "}
                <b className="txtclr">
                  $ {formatCurrency(data?.sellerMustNet || 0).toLocaleString()}
                </b>{" "}
                Seller Must Net, the Seller2Net <br />Estimated Sales Price will be
                <b className="txtclr"> ${" "}{formatCurrency(
                  data?.salesPrice || 0
                ).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                </b>{" "}
                based upon the information you provided.
              </p>
            </div>

            {/* summary table */}
            <div className="tbl-top-details top-tbl-mrgn">
              <table>
                <tbody>
                  <tr>
                    <td className="txt-left heading-e txtclr">
                      <span className="clrbody">Prepared for:</span>{" "}
                      {data?.preparedFor || "New Client"},{" "}
                      {data?.addressMeta?.address || ""}
                    </td>
                    <td className="txt-right heading-e txtclr">
                      <span className="clrbody">Closing County Office:</span>{" "}
                      {data?.addressMeta?.closing_county || "N/A"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* closing details */}
            <div className="tbl-type-a popup-tbl-td-width">
              <h3>Seller2Net Sheet - Conventional</h3>
              <table cellPadding="0" cellSpacing="0">
                <tbody>
                  <tr>
                    <td>Est. Closing Date</td>
                    <td>{formatDateMDY(data?.loanInfoMeta?.estimatedClosingDate)}</td>
                  </tr>
                  <tr>
                    <td>Seller Must Net</td>
                    <td>
                      ${" "}
                      {formatCurrency(
                        data?.sellerMustNet || 0.0
                      ).toLocaleString()}
                    </td>
                  </tr>
                  <tr>
                    <td>Closing Costs</td>
                    <td>
                      ${" "}
                      {formatCurrency(
                        data?.totalClosingMeta?.allCostsTotal || 0.0
                      ).toLocaleString()}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>Commissions</td>
                    <td>$ {formatCurrency(data?.totalClosingMeta?.compensationMetaTotal || 0.00).toLocaleString()}</td>
                  </tr> */}
                  <tr>
                    <td>Balance of All Loans</td>
                    <td>
                      ${" "}
                      {formatCurrency(
                        data?.loanInfoMeta?.loansToBePaidBalance1 || 0.0
                      ).toLocaleString()}
                    </td>
                  </tr>
                  {/* <tr>
                    <td>Annual Property Tax</td>
                    <td>$ {formatCurrency(data?.loanInfoMeta?.annualPropertyTaxAmount)}</td>
                  </tr> */}
                  {/* <tr>
                    <td>Home Warranty</td>
                    <td>$ {formatCurrency(data?.loanInfoMeta?.homeWarrantyAmount || 0.00).toLocaleString()}</td>
                  </tr> */}
                  <tr>
                    <td>
                      <b>Sales Price</b>
                    </td>
                    <td>
                      <b>
                        ${" "}
                        {formatCurrency(
                          data?.salesPrice || 0.0
                        ).toLocaleString()}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* fixed closing costs */}
            <div className="tbl-type-a popup-tbl-td-width">
              <h3>Fixed Closing Costs</h3>
              <div>
                <table cellPadding="0" cellSpacing="0">
                  <tbody>
                    <tr>
                      <td>Escrow or Settlement</td>
                      <td>
                        ${" "}
                        {formatCurrency(
                          data?.titleSettlementMeta?.escrowSettlementAmount
                        ) || 0.0}
                      </td>
                    </tr>
                    <tr>
                      <td>Owner Title Policy</td>
                      <td>
                        ${" "}
                        {formatCurrency(
                          data?.titleSettlementMeta?.ownersTitleAmount
                        ) || 0.0}
                      </td>
                    </tr>
                    <tr>
                      <td>Lenders Title Policy</td>
                      <td>
                        ${" "}
                        {formatCurrency(
                          data?.titleSettlementMeta?.lendersTitleAmount
                        ) || 0.0}
                      </td>
                    </tr>

                    {data.sellerClosingCostMeta.map((item, index) => (
                      <tr key={index}>
                        <td>{item.label || "—"}</td>
                        <td>
                          {"$"}{" "}
                          {/* use item.amount in case of key = "transfer_tax" else use item.value */}
                          {item.key === "transfer_tax"
                            ? formatCurrency(item.amount || 0)
                            : formatCurrency(item.value || 0)}
                        </td>
                      </tr>
                    ))}
                   
                    {
                      data.compensationMeta.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <strong>
                              {item.label || "—"}
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(
                              {formatCurrency(item.rate || 0)} %)
                            </strong>
                          </td>
                          <td>
                            <strong>$ {formatCurrency(item.value || 0)}</strong>
                          </td>
                        </tr>
                      ))
                    }

                    {data.closingCostMeta.map((item, index) => (
                      <tr key={index}>
                        <td>{item.label || "—"}</td>
                        <td>
                          {"$"} {formatCurrency(item.total || 0)}
                        </td>
                      </tr>
                    ))}

                    <tr>
                      <td>
                        <b>Total Fixed Costs</b>
                      </td>
                      <td>
                        <b>
                          ${" "}
                          {formatCurrency(
                            data?.totalClosingMeta?.sellerCostsTotal
                          ) || 0.0}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="tbl-type-a popup-tbl-td-width">
              <h3>Other Costs</h3>
              <div>
                <table cellPadding="0" cellSpacing="0">
                  <tbody>
                    {data.otherCostMeta.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.label || "—"} {formatCurrency(item.rate || 0)} %
                        </td>
                        <td>
                          {"$"} {formatCurrency(item.value || 0)}
                        </td>
                      </tr>
                    ))}
                    {data?.sellerOtherCostMeta?.map(
                      (item, index) =>
                        //ignore if key is in IGNORE_KEYS
                        !IGNORE_KEYS.includes(item.key) && (
                          <tr key={index}>
                            <td>{item.label || "—"}</td>
                            <td>
                              {"$"}{" "}
                              {formatCurrency(item.value || 0)}
                            </td>
                          </tr>
                        )
                    )}
                    <tr>
                      <td>
                        <b>Total Other Fees</b>
                      </td>
                      <td>
                        <b>
                          ${" "}
                          {formatCurrency(
                            data?.totalClosingMeta?.otherCostsTotal
                          ) || 0.0}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/*  <div class="tbl-type-a">
              <h3>Payments to Buyer</h3>
              <div>
                <table>
                  <tbody>
                    <tr><td>Total All Payments to Buyer</td><td>$ {formatCurrency(data?.totalClosingMeta?.allCostsTotal) || 0.00}</td></tr>
                    <tr><td><b>Estimated Seller Net</b></td><td><b>$ {formatCurrency(data?.totalClosingMeta?.estimatedSellerNet) || 0.00}</b></td></tr>
                  </tbody>
                </table>
              </div>
            </div> */}
          </div>

          {/* next button */}
          <div className="model-footer">
            <div className="model-popup-button-fixed next-step-btn">
              <button
                className="submit-btn btn-bg inpt-btn"
                onClick={() => setStep(2)}
              >
                Next
              </button>
            </div>
          </div>
        </>
      ) : (
        // ✅ Step 2 — Next Actions
        <div className="model-body">
          <div className="model-popup-style">
            <div className="requiredlist-md">
              <ul>
                <li className="icon-requiredlist reqlst-edit">
                  <button

                    onClick={(e) => {
                      e.preventDefault();
                      handleClose();
                      onEditManual(); // open manual edit
                    }}
                  >
                    Open and edit the sheet manually
                  </button>
                </li>

                <li className="icon-requiredlist reqlst-download">
                  <button

                    onClick={(e) => {
                      e.preventDefault();
                      handleDownloadPrintPDF("download");
                    }}
                  >
                    Download this sheet
                  </button>
                </li>
                <li className="icon-requiredlist reqlst-print">
                  <button

                    onClick={(e) => {
                      e.preventDefault();
                      handleDownloadPrintPDF("print");
                    }}
                  >
                    Print this sheet
                  </button>
                </li>
                <li className="icon-requiredlist reqlst-email">
                  <button

                    onClick={(e) => {
                      const isValid = checkValidSalesPrice();
                      if (!isValid) return;
                      e.preventDefault();
                      const updated = getValues();
                      openModal({
                        title: "Email a Closing Cost Estimate",
                        size: "mediumsizewidth",
                        content: (
                          <EmailModal
                            onClose={cancelResultModal}
                            type="seller"
                            showToaster={showToaster}
                            sellerFormData={updated}
                          />
                        ),
                      });
                    }}
                  >
                    Email this sheet
                  </button>
                </li>
                {!isGuestUser(user) && (
                  <li className="icon-requiredlist reqlst-save">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        handleSaveCalc();
                      }}
                    >
                      Save sheet to be accessed later
                    </button>
                  </li>
                )}
                <li className="icon-requiredlist reqlst-cancel">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      cancelModal();
                    }}
                  >
                    Cancel
                  </button>
                </li>
                <li className="icon-requiredlist reqlst-exit">
                  <button

                    onClick={(e) => {
                      handleExit(e);
                    }}
                  >
                    Exit
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
